import type { SavedPlanIDs } from "Utils/types";

export const TOGGLE_SAVE_PLAN = "ComparePlans/TOGGLE_SAVE_PLAN";
export const CLEAR_ALL_COMPARE_PLANS = "ComparePlans/CLEAR_ALL_COMPARE_PLANS";

type ToggleSavePlanLocation = "plan_card_bottom_right" | "saved_plan_box";

type ToggleSavedPlanAction = {
  type: typeof TOGGLE_SAVE_PLAN;
  planID: string;
  meta: {};
  fromSidebar?: Boolean;
};

// Action creators

export function toggleSavePlan(planID: string, location: ToggleSavePlanLocation, fromSidebar?: Boolean) {
  return {
    type: TOGGLE_SAVE_PLAN,
    planID,
    meta: {
      analytics: {
        type: "plan_added_to_compare",
        properties: {
          plan_id: planID,
          location,
          deprecatedName: "select-filter/toggle_save_plan",
          deprecatedLabel: null,
          deprecatedValue: planID,
        },
      },
    },

    fromSidebar,
  };
}

export function clearAllComparePlans() {
  return {
    type: CLEAR_ALL_COMPARE_PLANS,
  };
}

// Selectors

export const getSavedPlanIDs = (state: any): Array<string> => state.savedPlanIDs;

// Reducer

export type ComparePlansState = {
  savedPlanIDs: SavedPlanIDs;
};

export function savedPlanIDs(state: Array<string> = [], action: ToggleSavedPlanAction): Array<string> {
  switch (action.type) {
    case TOGGLE_SAVE_PLAN:
      if (state.includes(action.planID)) {
        // Remove if already added
        return state.filter((id) => id !== action.planID);
      }
      if (action.fromSidebar) {
        // Clicking compare in the sidebar should prioritize cart plans first
        const [id1, id2, id3] = state;
        return [action.planID, id1, id2, id3].filter((e) => e);
      }
      if (state.length > 3) {
        // Do not register clicks when four or more plans are already saved
        return state;
      }
      // Otherwise add the plan to the list of saved plans
      const [id1, id2, id3] = state;
      return [id1, id2, id3, action.planID].filter((e) => e);

    case CLEAR_ALL_COMPARE_PLANS:
      return [];
    default:
      return state;
  }
}
